import { useState, useEffect } from 'preact/hooks'

const useCurrentRoute = () => {
    const [currentPath, setCurrentPath] = useState(window.location.pathname)

    useEffect(() => {
        const handleRouteChange = () => {
            setCurrentPath(window.location.pathname)
        }

        // Listen for popstate events (back/forward navigation)
        window.addEventListener('popstate', handleRouteChange)

        // Listen for pushstate/replacestate events (programmatic navigation)
        const originalPushState = window.history.pushState
        const originalReplaceState = window.history.replaceState

        window.history.pushState = function (...args) {
            originalPushState.apply(window.history, args)
            handleRouteChange()
        }

        window.history.replaceState = function (...args) {
            originalReplaceState.apply(window.history, args)
            handleRouteChange()
        }

        // Also listen for custom route change events that preact-router might emit
        const handleCustomRouteChange = () => {
            setCurrentPath(window.location.pathname)
        }
        
        // Listen for any custom events that might be emitted during navigation
        window.addEventListener('routechange', handleCustomRouteChange)

        return () => {
            window.removeEventListener('popstate', handleRouteChange)
            window.removeEventListener('routechange', handleCustomRouteChange)
            window.history.pushState = originalPushState
            window.history.replaceState = originalReplaceState
        }
    }, [])

    return currentPath
}

export default useCurrentRoute
